import { render, staticRenderFns } from "./LabourView.vue?vue&type=template&id=3fde1e28&scoped=true"
import script from "./LabourView.vue?vue&type=script&lang=js"
export * from "./LabourView.vue?vue&type=script&lang=js"
import style0 from "./LabourView.vue?vue&type=style&index=0&id=3fde1e28&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fde1e28",
  null
  
)

export default component.exports